import { render, staticRenderFns } from "./DeactivatedAccount.vue?vue&type=template&id=1cc9cdf6"
import script from "./DeactivatedAccount.vue?vue&type=script&lang=js"
export * from "./DeactivatedAccount.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports